import type { ReplicantConfig } from '../utils/types';
import type { WithMeta } from '@play-co/replicant';
import { State } from '../State';
import { getDynamicTestBucket } from '../getters/ab';
import ab from './ab';
import { isGuestUser } from '../utils';

export default function <
  T extends Partial<State> & { ruleset: State['ruleset'] }
>(state: WithMeta<T, ReplicantConfig['ruleset']>) {
  return {
    friendReferral: false,
    gifts: false,
    ingameProfile: true,
    visitFriend: false,
    duo: false,
    fate: true,
    nativeIos: true,
    nativeAndroid: true,
    showCrossplayPromoOnGemsShopOpen: false,
    showInvitePopupOnGemsShopOpen: false,
    familyTree: false,
  };
}
